import api from '../../store/config/api';
import file from '../../store/config/file';
import { WEBHOOK as SCHEMA } from '../../schemas';
import context from '../../util/context';

export const [
  GET_WEBHOOK,
  GET_WEBHOOK_REQUEST,
  GET_WEBHOOK_SUCCESS,
  GET_WEBHOOK_FAILURE
] = api.buildTypes('GET_WEBHOOK');

export function getWebhook({ webhookID }) {
  return {
    type: GET_WEBHOOK,
    payload: {
      url: `/webhooks/${webhookID}`,
      schema: SCHEMA
    }
  };
}

export const [
  POST_WEBHOOK,
  POST_WEBHOOK_REQUEST,
  POST_WEBHOOK_SUCCESS,
  POST_WEBHOOK_FAILURE
] = file.buildTypes('POST_WEBHOOK');

export function postWebhook({ webhookID, fields = [] }) {
  const url = `/webhooks/${webhookID}`;
  const formData = new context.FormData();

  fields.forEach(field => {
    if (!field.hasOwnProperty('value') || field.value == null) {
      if (field.type === 'string') {
        field.value = '';
      } else {
        return;
      }
    }
    if (Array.isArray(field.value)) {
      field.value.forEach(val => {
        formData.append(field.fieldName, val);
      });
    } else {
      formData.append(field.fieldName, field.value);
    }
  });

  return {
    type: POST_WEBHOOK,
    payload: {
      json: false,
      url,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: formData
      }
    }
  };
}

export const [
  CREATE_WEBHOOK,
  CREATE_WEBHOOK_REQUEST,
  CREATE_WEBHOOK_SUCCESS,
  CREATE_WEBHOOK_FAILURE
] = api.buildTypes('CREATE_WEBHOOK');

export function createWebhook({ webhook, teamName }) {
  const url = `teams/${teamName}/webhooks`;

  return {
    type: CREATE_WEBHOOK,
    payload: {
      url,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: webhook
      }
    }
  };
}

export const [
  UPDATE_WEBHOOK,
  UPDATE_WEBHOOK_REQUEST,
  UPDATE_WEBHOOK_SUCCESS,
  UPDATE_WEBHOOK_FAILURE
] = api.buildTypes('UPDATE_WEBHOOK');

export function updateWebhook({ webhook, teamName }) {
  const url = `teams/${teamName}/webhooks/${webhook.webhookID}`;

  return {
    type: UPDATE_WEBHOOK,
    payload: {
      url,
      schema: SCHEMA,
      options: {
        method: 'PUT',
        body: webhook
      }
    }
  };
}

export const [
  DELETE_WEBHOOK,
  DELETE_WEBHOOK_REQUEST,
  DELETE_WEBHOOK_SUCCESS,
  DELETE_WEBHOOK_FAILURE
] = api.buildTypes('DELETE_WEBHOOK');

export function deleteWebhook({ teamName, webhookID }) {
  return {
    type: DELETE_WEBHOOK,
    payload: {
      url: `teams/${teamName}/webhooks/${webhookID}`,
      schema: SCHEMA,
      options: {
        method: 'DELETE'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/webhook.js